define('views/modules/setting/business/blocks/brand/brand-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/app-state',
    // views
    'views/parts/form/textbox',
    'views/parts/form/choices',
    'views/parts/form/color-picker',
    'views/parts/info-section',
    'views/parts/modal/image-modal',
    // templates
    'text!templates/modules/setting/business/blocks/brand/brand-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    AppState,
    // views
    VTextBox,
    VChoices,
    VColorPicker,
    VInfoSection,
    VImageModal,
    // templates
    TBrandEditForm
) {
    var VBrandEditForm = Backbone.Epoxy.View.extend({
        template: TBrandEditForm,

        events: {
            "click #brand-photo-edit": "onLogoClick",
            "click .edit-button": "onLogoClick",
        },

        regions: {
            form: {
                colorpicker: ".color-picker-container",
                text: ".brand-text",
                choices: ".brand-choices",
                logo: "#brand-photo-edit",
                logoContainer: ".brand-image",
                companyName: ".brand-company-name"
            }
        },

        initialize: function(opt) {
            this.options = opt || {};

            var choicesFilter = [
                { label: 'settings:brand-logo-button', value: 'image' },
                { label: 'settings:brand-text-button', value: 'text' }
            ];

            var view = this.view = {
                info: new VInfoSection({
                    title: "settings:brand-title",
                    content: this.template,
                }),
                form: {
                    companyName: new VTextBox({
                        label: "settings:brand-company-name",
                        labelposition: 'top',
                        attribute: 'name',
                        model: this.model,
                        onChange: this.onTextChange,
                        context: this,
                    }),
                    colorpicker: new VColorPicker({
                        attribute: 'brandColor',
                        model: this.model,
                        label: "settings:brand-choose-color"
                    }),
                    choices: new VChoices({
                        groupLabel: "settings:brand-choice-title",
                        choices: choicesFilter,
                        model: this.model,
                        attribute: 'logoType',
                        radio: true,
                        styleButton: true,
                        onChange: this.onLogoTypeChange,
                        addClass: "btn-group-sm",
                        context: this,
                    }),
                    text: new VTextBox({
                        label: "settings:brand-text-title",
                        labelposition: 'top',
                        attribute: 'logoText',
                        model: this.model,
                        onChange: this.onTextChange,
                        context: this,
                    }),
                }
            };

            this.listenTo(this.model, { "change:backgroundColor": this.onColorChange, });
        },

        render: function() {
            this.assign(this.view.info, this.$el)
                .applyBindings();

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form.colorpicker, zone.form.$colorpicker)
                .assign(view.form.text, zone.form.$text)
                .assign(view.form.choices, zone.form.$choices)
                .assign(view.form.companyName, zone.form.$companyName);

            this.initLogoData();

            this.toggleTextBrandAndImage();

            return this;
        },

        initLogoData: function() {
            var logoData = this.model.getLogo();

            if (this.model.isLogoImage()) {
                this.options.logoURL = logoData.data;
                this.options.logoText = "";
            } else {
                this.options.logoURL = "assets/images/placeholer-image-300x100.jpg";
                this.options.logoText = logoData.data;
            }
        },

        showLogoModal: function() {
            var view = this.view.modal;
            if (!view) {
                this.view.modal = view = new VImageModal({
                    title: "settings:brand-upload-modal-title",
                    context: this,
                    callback: this.onLogoChange,
                });
            }
            view.show();
        },

        setTypeInputValue: function(value) {
            var logo = this.model.getLogo();

            if (!value) value = logo.data;

            this.view.form.text.setValue(value);
        },

        setLogoPreview: function(blob) {
            var logoUrl = URL.createObjectURL(blob),
                $logo = this.zone.form.$logo;
            $logo.attr('src', logoUrl);
        },

        toggleTextBrandAndImage: function() {
            var zone = this.zone.form;

            if (this.model.isLogoImage()) {
                zone.$logoContainer.toggle(true);
                zone.$text.toggle(false);
            } else {
                zone.$logoContainer.toggle(false);
                zone.$text.toggle(true);
            }
        },

        ////////////
        // events //
        ////////////

        onLogoClick: function(e) {
            this.showLogoModal();
        },

        onLogoChange: function(confirmed, blob, modal) {
            if (confirmed && blob) {
                this.model.setLogoFile(blob);

                this.setLogoPreview(blob);
            }
        },

        onLogoTypeChange: function(model, value) {
            var type = this.view.form.choices.getValue();
            var currentLogoData = this.model.getLogo().data;

            if (this.model.isLogoImage()) {
                this.model.setLogoData(this.options.logoURL);
                this.options.logoText = currentLogoData;
            } else {
                this.model.setLogoData(this.options.logoText);
                this.options.logoURL = currentLogoData;
            }

            this.toggleTextBrandAndImage();
        },

        onColorChange: function(model, value, options) {
            //if invalid color, default blue TC
            if (!/^#[0-9A-F]{6}$/i.test(value)) {
              value = '#00adef';
            }
            if (value) {
                AppState.setBrandColor(value);
            }
        },

        onTextChange: function() {
            var text = this.view.form.text.getValue();

            this.model.setLogoData(text);
        }

    });

    return VBrandEditForm;
});

